import { BASE_ADMIN_URL } from "@shared/api/constants";
import axios from "axios";

export const axiosAdminPrivate = axios.create({
  baseURL: BASE_ADMIN_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

axiosAdminPrivate.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export const axiosAdminPublic = axios.create({
  baseURL: BASE_ADMIN_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});
